export const internationalAvsAnalytics = {
  trackBannerRequestAccessClick: applicationId => {
    window.analytics.track('InternationalAvsBannerRequestAccessClick', {
      application_id: applicationId,
    });
  },

  trackBannerDocumentationClick: applicationId => {
    window.analytics.track('InternationalAvsBannerDocumentationClick', {
      application_id: applicationId,
    });
  },

  trackBannerCloseClick: applicationId => {
    window.analytics.track('InternationalAvsBannerCloseClick', {
      application_id: applicationId,
    });
  },
}; 